import $foreign from "./foreign.cjs";
var _genUUIDImpl = $foreign._genUUIDImpl;
var isValidUUID = $foreign.isValidUUID;
export { _genUUIDImpl, isValidUUID };
